module.exports = __webpack_public_path__ + "static/media/phonepay.448144cf.jpg";